import { AudienceBroadcastMessageStatus } from '@occc/graphql';

export const EDITABLE_CAMPAIGN_STATUSES = [
  AudienceBroadcastMessageStatus.Draft,
  AudienceBroadcastMessageStatus.Scheduled,
];
